import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from 'react';

import { v4 as uuidv4 } from 'uuid';

import { loadingContext } from './GlobalLoading.utils';

export const useGlobalLoading = (queryKey?: readonly unknown[]) => {
  const dependencyArray = Array.isArray(queryKey) ? queryKey : [queryKey];
  const loadingId = useMemo(() => (
    queryKey ?? [uuidv4()]
  ), dependencyArray);

  const {
    startLoading: originalAdd,
    endLoading: originalRemove,
    setContent: setContentContext,
    isLoading,
    loadingQueueRef,
  } = useContext(loadingContext);
  const startLoading = useCallback(() => originalAdd(loadingId), loadingId);
  const endLoading = useCallback(() => originalRemove(loadingId), loadingId);

  const setContent = useCallback((content) => {
    setContentContext(content);
  }, [setContentContext]);

  const stringLoadingId = useMemo(() => loadingId.join(), loadingId);
  const prevStringLoadingIdRef = useRef(stringLoadingId);

  useEffect(() => {
    if (stringLoadingId !== prevStringLoadingIdRef.current) {
      // launch a new timer for the new key
      startLoading();
    }
    prevStringLoadingIdRef.current = stringLoadingId;
    return () => {
      // every time the queryKey changes the previous one ends
      endLoading();
    };
  }, [stringLoadingId]);

  return {
    endLoading, isLoading, loadingQueueRef, setContent, startLoading,
  };
};
